export default __webpack_public_path__ + "static/media/history_1970_00.0b9420b7.png";